import { render } from "./TagOverflowPopover.vue?vue&type=template&id=4cbb5978"
import script from "./TagOverflowPopover.vue?vue&type=script&lang=js"
export * from "./TagOverflowPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__